import { render } from "./vueperslides.vue?vue&type=template&id=07072546&lang=pug"
import script from "./vueperslides.vue?vue&type=script&lang=js"
export * from "./vueperslides.vue?vue&type=script&lang=js"

import "./vueperslides.vue?vue&type=style&index=0&id=07072546&lang=scss"
script.render = render

export default script